
import { useState } from "react";
import { API } from "../assets/staticData";
import { toast } from "react-toastify";

export const useUploader = () => {

  const [isLoading, setIsLoading] = useState(false)

  const upload = async (file) => {

    if (!file) return null

    setIsLoading(true)

    const userToken = localStorage.getItem("userToken");

    const formData = new FormData();

    formData.append("files", file);

    const toastId = toast(`File Uploading...`, { type: "info", isLoading: true, autoClose: false, });
    try {

      const res = await fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`
        },
        body: formData,
      });

      toast.dismiss(toastId)
      toast(`File Uploaded successfully.`, { type: "success" });
      setIsLoading(false)
      return (await res.json())[0];
    } catch (error) {

      console.log(error)
      toast.dismiss(toastId)
      toast(`Unable Upload File. Please try again`, { type: "error" });
      setIsLoading(false)
      return null
    }

  }

  const uploadMultiple = async (files) => {

    if (!files.length) return null
    setIsLoading(true)

    const userToken = localStorage.getItem("userToken");

    const formData = new FormData();

    files.forEach((file) => {
      formData.append("files", file);
    });

    try {

      const res = await fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`
        },
        body: formData,
      });
      setIsLoading(false)

      return await res.json();
    } catch (error) {
      setIsLoading(false)
      console.log(error)
      return null
    }

  }

  const getFileFromUrl = async (url, fileName) => {
    const response = await fetch(url);
    const blob = await response.blob();

    // Try to get MIME type from response
    const contentType = response.headers.get("content-type") || blob.type || "application/octet-stream";

    return new File([blob], fileName, { type: contentType });
  };

  return {
    isLoading,
    upload,
    uploadMultiple,
    getFileFromUrl
  }
}
